import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPONSE_AGENT_CREATE,
    RESPONSE_AGENT_UPDATE,
    RESPONSE_AGENT_DELETE,
    RESPONSE_AGENT_LIST,
    RESPONSE_AGENT_ENABLE,
    RESPONSE_AGENT_TEST,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import { AgentConfig, CannedPrompt } from "userful-chronos-app-common-js/dist/models/eisenhower/agent/agents";
import eisenhowerStore from "../eisenhowerStore";
import { eisenhowerActions } from "../eisenhowerSlice";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { ConfirmationToastContentStore } from "../../../Container/ConfirmationToastContentStore";
import { toast } from "react-toastify";

registerMsgHandler(RESPONSE_AGENT_CREATE, (payload) => {
    console.debug("receive RESPONSE_AGENT_CREATE");
    const data = JSON.parse(payload) as AgentConfig;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateAgents(data));
    eisenhowerStore.dispatch(eisenhowerActions.setShowAgentRedirect(true));
});

registerMsgHandler(RESPONSE_AGENT_UPDATE, (payload) => {
    console.debug("receive RESPONSE_AGENT_UPDATE");
    const data = JSON.parse(payload) as AgentConfig;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateAgents(data));
});

registerMsgHandler(RESPONSE_AGENT_DELETE, (payload) => {
    console.debug("receive RESPONSE_AGENT_DELETE");
    const data = JSON.parse(payload) as StringID;
    eisenhowerStore.dispatch(eisenhowerActions.removeAgent(data));
});

registerMsgHandler(RESPONSE_AGENT_LIST, (payload) => {
    console.debug("receive RESPONSE_AGENT_LIST");
    const data = JSON.parse(payload) as AgentConfig[];
    eisenhowerStore.dispatch(eisenhowerActions.setAgents(data));
});

registerMsgHandler(RESPONSE_AGENT_ENABLE, (payload) => {
    console.debug("receive RESPONSE_AGENT_ENABLE");
    const data = JSON.parse(payload) as AgentConfig;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateAgents(data));
});

registerMsgHandler(RESPONSE_AGENT_TEST, (payload) => {
    console.debug("receive RESPONSE_AGENT_TEST");
    const data = JSON.parse(payload) as AgentConfig;
    const customDisplay = ConfirmationToastContentStore(data.name, "Confirm", "Test run was successful");
    toast(customDisplay, { containerId: "confirmationContainer" });
});
